import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isAndroid, isBrowser, isIos } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.DeveloperTools
const label = visitFilterLabelMap[key]

export const developerToolsColumn = () =>
  columnHelper.display({
    id: 'developerTools',
    header: 'Developer Tools',
    cell: ({ row }) => {
      if (!isBrowser(row.original) && !isAndroid(row.original) && !isIos(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.developer_tools

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
